<template>
  <div class="home">
    <b-container fluid>
      <nav-bar-component v-on:validated-user="companyId = $event; getAllTheData();"></nav-bar-component>
      <setup-menu-nav-component></setup-menu-nav-component>
    </b-container>
   
    <b-container fluid class="main-box">
      <b-row class="justify-content-md-center">
      <b-col>
      </b-col>
      <b-col cols="10">
        <b-card-group deck>
          <b-card title="Notification Status" class="chart-container">
            <apexchart id="vuechart-example" type="bar" :options="chartOptions" :series="series" v-if="isLoaded"></apexchart>
          </b-card>

          <b-card title="Notification Engagement" class="chart-container">
            <apexchart id="button-chart" type="donut" :options="buttonChartOptions" :series="buttonSeries" v-if="buttonChartLoaded"></apexchart>
          </b-card>

          <b-card title="Notification Activity" class="chart-container">
            <apexchart id="activity-time-chart" type="area" :options="activityTimeChartOptions" :series="activityTimeSeries" v-if="activityTimeChartLoaded"></apexchart>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col>
      </b-col>
      </b-row>
      <b-row>
        <b-col>

        </b-col>
        <b-col cols="4">          
            <b-card title="Template Stats" class="chart-container">
              <b-table hover 
                      :items="templateList" 
                      :fields="tableFields" 
                      selectable 
                      :select-mode="selectMode" 
                      @row-selected="onRowSelected"
                      selected-variant="info"
                      ref="templateTable">
              </b-table>
            </b-card>
        </b-col>
        <b-col cols="6">
          <template-chart-component :templateId="selectedTemplateId" v-if="templateLoaded"></template-chart-component>
        </b-col>
        <b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import NavBarComponent from '@/components/NavBarComponent.vue'
import SetupMenuNavComponent from '@/components/SetupMenuNavComponent.vue'
import TemplateChartComponent from '@/components/TemplateChartComponent.vue'
// @ is an alias to /src
var Parse = require('parse/node');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY, process.env.VUE_APP_PARSE_MASTER_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;
var moment = require('moment');

export default {
  name: 'Home',
  components: {
    'apexchart': VueApexCharts,
    NavBarComponent,
    SetupMenuNavComponent,
    TemplateChartComponent
  },
  data: () => {
    return {
      companyId : '',
      notificationList: [],      
      chartOptions : null,      
      series : null,
      buttonChartOptions : null,      
      buttonSeries : null,
      activityTimeChartOptions : null,
      activityTimeSeries : null,
      isLoaded : false,
      buttonChartLoaded : false,
      activityTimeChartLoaded : false,
      templateList : [],
      tableFields :[
          {
            key: 'name',
            label: 'Template name',
            sortable: false
          },
        ],
      selectedTemplate : [],
      selectedTemplateId : '',
      selectMode : 'single',
      templateLoaded : false
    }
  },

  created() {
    
  },

  mounted() {
    
  },

  methods: {
    getAllTheData() {
      console.log('companyId = ' + this.companyId);
      this.fetchTemplateList();
      this.fetchTopLineMetrics();
      this.fetchClickMetrics();
      this.fetchActivityOverTime();
      
    },

    fetchTopLineMetrics() {
      const AppMessage = Parse.Object.extend("AppMessage");
      const query = new Parse.Query(AppMessage);
      console.log('companyId = ' + this.companyId);
      
      var pipeline = [
        { match: { CompanyId: this.companyId  } },
        { group: { objectId: '$Status', 
                   total: { $sum: 1 } 
                 } 
        }
      ];      

      query.aggregate(pipeline).then((results) => {
        let localXaxis = [];
        let localYaxis = [];
        let totalNotifications = 0;
        results.forEach(element => {
          let cur = JSON.parse(JSON.stringify(element));
          console.log('element: ' + JSON.stringify(element));
          if (cur.objectId) {
            localXaxis.push(cur.objectId);
            localYaxis.push(cur.total);
            totalNotifications += cur.total;
          } 
        });
        localXaxis.push('Total');
        localYaxis.push(totalNotifications);
        console.log('localxaxis = ' + localXaxis);
        console.log('localyseries = ' + localYaxis);
        this.chartOptions = {
          chart: {
            id: 'vuechart-example',
            toolbar: {
              show: false,
            }
          },
          xaxis: {
            categories: localXaxis
          },
          plotOptions: {
            bar: {
              distributed: true
            }
          },
          /*
          theme: {
            palette: 'palette8' // upto palette10
          }
          */
          
          theme: {
            monochrome: {
              enabled: true,
              //color: '#775dd0',
              color: '#5520a7',
              shadeTo: 'light',
              shadeIntensity: 0.9
            }
          }
          
        };

        this.series = [
          {
            name: "Notifications",
            data: localYaxis
          }
        ];
        console.log('xaxis = ' + this.chartOptions.xaxis.categories);
        console.log('series = ' + this.series[0].data);
        this.isLoaded = true;
      })
    },
    fetchClickMetrics: async function () {
      const AppMessage = Parse.Object.extend("AppMessage");
  
      const querySeenNotClicked = new Parse.Query(AppMessage);
      querySeenNotClicked.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.companyId });
      querySeenNotClicked.exists("Button1Status");
      querySeenNotClicked.notEqualTo("Button1Status", "NA");
      querySeenNotClicked.equalTo("Status", "Read");
      querySeenNotClicked.doesNotExist("LastClickTime");
      let totalSeenNotClicked = await querySeenNotClicked.count();
      console.log('totalSeenNotClicked = ' + totalSeenNotClicked);

      const queryTotalClicked = new Parse.Query(AppMessage);
      queryTotalClicked.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.companyId });
      queryTotalClicked.exists("LastClickTime");      
      let totalClicked = await queryTotalClicked.count();
      console.log('totalClicked = ' + totalClicked);
      
      let vals = [];
      vals.push(totalClicked);
      vals.push(totalSeenNotClicked);

      this.buttonChartOptions = {       
        chart: {
          id: 'button-chart',
          toolbar: {
            show: false,
          }
        },
        
        labels: ['Clicked', 'No Engagement'],
        
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,                  
                },
                value: {
                  show: true
                },
                total: {
                  show: true
                }
              }
            }
          }
        },
        theme: {
          monochrome: {
            enabled: true,
            //color: '#775dd0',
            color: '#5520a7',
            shadeTo: 'light',
            shadeIntensity: 0.9
          }
        }
      };

      this.buttonSeries = vals;

      this.buttonChartLoaded = true;
      
    },

    fetchActivityOverTime: async function () {
      const AppMessage = Parse.Object.extend("AppMessage");
      const query = new Parse.Query(AppMessage);
      query.descending("createdAt");
      var pipeline = [
        { match: { CompanyId: this.companyId  } },
        { group: { objectId: { month: { $month: "$createdAt" }, day: { $dayOfMonth: "$createdAt" }, year: { $year: "$createdAt" }, status: '$Status' },
                   total: { $sum: 1 } 
                 } 
        }
      ];      
      let timeSeriesData = [];
      let timeSeriesDataUnread = [];
      let results = await query.aggregate(pipeline);
      //console.log('results = ' + JSON.stringify(results));
      let resultMap = new Map();
      let keySet = [];
      results.forEach(element => {
        let cur = JSON.parse(JSON.stringify(element));
        let curKey = new Date(cur.objectId.year, cur.objectId.month - 1, cur.objectId.day).getTime();
        keySet.push(curKey);
        let curVal = {}
        if (resultMap.has(curKey)) {
          curVal = resultMap.get(curKey);
        }
        if (cur.objectId.status == 'Unread') {
          curVal.unread = cur.total;
        } else if (cur.objectId.status == 'Read') {
          curVal.read = cur.total;
        }
        resultMap.set(curKey, curVal);
      });

      keySet.sort();
      keySet.forEach(cur => {
        //console.log('data point: ' + moment(cur).format() + ' : ' + resultMap.get(cur));
        let curObj = resultMap.get(cur);
        if (curObj.unread) {
          timeSeriesDataUnread.push({
            x: cur,
            y: curObj.unread
          })
        }
        if (curObj.read) {
          timeSeriesData.push({
            x: cur,
            y: curObj.read
          })
        }
      });

      this.activityTimeChartOptions = {
        chart: {
            id: 'activity-time-chart',
            type: "area",
            stacked: false,
            toolbar: {
              show: false,
            }
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: "datetime",
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        /*
        theme: {
          palette: 'palette8'
        },
        */
        colors: ['#5520a7', '#ffb03a', '#546E7A', '#E91E63', '#FF9800']
      };
      this.activityTimeSeries = [
        {
          name: 'Read notifications',
          data: timeSeriesData
        },
        {
          name: 'Unread notifications',
          data: timeSeriesDataUnread  
        }];

      
      this.activityTimeChartLoaded = true;
      
    },

    fetchTemplateList: async function() {
      const NotificationTemplate = Parse.Object.extend("NotificationTemplate");
      const query = new Parse.Query(NotificationTemplate);
      query.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.companyId });
      query.ascending("Name");
      let resultList = await query.find();
        //wrap templates
      resultList.forEach(cur => {
        let templateWrapper = {
          id : cur.id,
          name : cur.get("Name")
        }
        this.templateList.push(templateWrapper);
      });
      console.log('finished loading template list');

      this.$nextTick(function() {
        this.selectFirst();
      });
    },
    selectFirst: async function() {
      console.log('in select first');
      this.$refs.templateTable.selectRow(0)
      this.templateLoaded = true;
    },
    onRowSelected(item) {
      console.log('item = ' + item);
      this.selectedTemplate = item;
      this.selectedTemplateId = item[0].id;
    },
  }
}
</script>

<style>
  .chart-container  {
    box-shadow: 0px 1px 22px -12px #607D8B;
    background-color: #fff;
  }
  
  .main-box .row {
    margin-top: 20px;
  }
</style>